module.exports = __webpack_public_path__ + "static/half-elf-female-AYAGWW-66adb7f935c4e43d5c9b777f2f04c145.png";